import React from "react";
import PropTypes from "prop-types";
import EmptyField from "UIComponents/EmptyField";
import I18nHOC from "UIComponents/I18nHOC";
import classes from "./KeyConcepts.scss";
import SelectKCModal from "../SelectKCModal";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import { isNewPYPConceptsLabelEnabled } from "lib/i18nHelperVariables";

class KeyConcepts extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      modalVisible: false,
      isEditModal: false,
    };
  }

  componentDidMount = () => {
    const { isCourseOverview } = this.props;
    if (isCourseOverview) {
      // need to simulate edit click for course overview
      this.onEditClick();
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { modalVisible } = this.state;
    const { modalVisible: prevModalVisible } = prevState;
    if (modalVisible != prevModalVisible) {
      if (modalVisible) {
        this.onFocus();
      } else {
        this.onBlur();
      }
    }
  };

  blur = () => {
    this.setState({ modalVisible: false });
  };

  renderLock = () => {
    return null;
  };

  onEditClick = () => {
    this.setState({ modalVisible: true, isEditModal: true });
  };

  updateInputField = params => {
    const { options } = this.props;
    this.updateValue(params[this.props.name], { nodes: options });
  };

  shouldShowEditEmpty = () => {
    const { value } = this.props;
    return !this.isValidValue(value);
  };

  renderResponseHeader = () => {
    const { responseHeaderText, mode } = this.props;
    return (
      !!responseHeaderText &&
      mode == "edit" && (
        <div
          className={classes.extraTextContainer}
          dangerouslySetInnerHTML={{ __html: responseHeaderText }}
        ></div>
      )
    );
  };

  renderEditEmpty = () => {
    const { fieldKey, t } = this.props;
    const title =
      fieldKey === "action"
        ? t("common:add_with_label", { label: t("common:action_label") })
        : isNewPYPConceptsLabelEnabled()
        ? t("common:add_with_label", { label: t("common:key_concept_updated") })
        : t("common:add_concept_plural");
    const onAddNewCallBack = () =>
      this.setState({ modalVisible: true, isEditModal: false });
    return (
      <div className={classes.innerContainer}>
        {this.renderResponseHeader()}
        <EmptyField
          title={title}
          showAdd={true}
          onAddNewClick={onAddNewCallBack}
        />
      </div>
    );
  };

  getLabel = () => {
    const { fieldKey, t } = this.props;

    const label =
      fieldKey === "action"
        ? t("common:action_label")
        : isNewPYPConceptsLabelEnabled()
        ? t("common:key_concepts_updated")
        : t("common:concept_plural");

    return label;
  };

  renderChildren = () => {
    const { t, fieldKey, value, testId } = this.props;
    const addLabel = this.state.isEditModal
      ? t("common:update_with_label", { label: this.getLabel() })
      : fieldKey === "action"
      ? t("common:add_with_label", { label: t("common:action_label") })
      : isNewPYPConceptsLabelEnabled()
      ? t("common:add_with_label", { label: t("common:key_concept_updated") })
      : t("common:add_concept_plural");

    return (
      <>
        {!this.shouldShowEmpty(value) && this.renderResponseHeader()}
        {this.state.modalVisible ? (
          <SelectKCModal
            addLabel={addLabel}
            updateInputField={this.updateInputField}
            keyConcepts={this.props.options}
            selectedKeyConcepts={this.props.value}
            name={this.props.name}
            isEdit={this.state.isEditModal}
            updateValueLocally={this.updateValueLocally}
            onCancelClick={() => this.setState({ modalVisible: false })}
            testId={`${testId}-selectKCModal`}
          />
        ) : null}
      </>
    );
  };

  renderEdit = () => {
    return null;
  };
}

KeyConcepts.propTypes = {
  ...UIBaseComponent.propTypes,
  options: PropTypes.array,
  title: PropTypes.string,
  isCourseOverview: PropTypes.bool,
};

KeyConcepts.defaultProps = {
  ...UIBaseComponent.defaultProps,
  title: "",
  options: [],
  value: [],
  isCourseOverview: false,
};

export default I18nHOC({ resource: ["unitPlan", "common"] })(KeyConcepts);
